/* eslint-disable @nx/enforce-module-boundaries */
import { ColDef, ColumnState } from '@ag-grid-community/core';
import { FilterValue } from '@ellf/common-interfaces';
import { ExcelFieldConfig } from './excel';
import { getGridColumnType, mapFromColumnState } from './ag-grid-utils';
import { EntityListField } from './entity-list-field';
import { SharedFacadeInterface } from './shared-facade.interface';

export function getTabGridColumns(
  gridColumns: EntityListField[],
  visibleColumns: string[],
  excludeColumns: string[],
) {
  return gridColumns
    .filter((gc) => !excludeColumns.find((c) => c === gc.field))
    .map(
      (f) =>
        ({
          colId: f.field,
          initialHide: !visibleColumns.find((c) => c === f.field),
          field: f.field,
          headerName: f.elementLabel,
          type: getGridColumnType(f.filterType, f.fieldType),
          sortable: f.sortable,
          sort: f.sort,
        }) as ColDef,
    );
}

export const getExcelFields = (
  fields: EntityListField[],
  columnState: ColumnState[],
  excludeColumns: string[] = [],
) => {
  const sortedFields = columnState
    .filter((c) => !c.hide)
    .map((c) => fields.find((f) => c.colId === f.field))
    .filter((c) => c != null) as EntityListField[];

  return sortedFields
    .map((f) => {
      return {
        name: f.field,
        label: f.elementLabel,
        type: f.fieldType,
        elementValues: f.elementValues,
        hidden: f.exportHideColumn,
        valueGetter: f.valueGetter,
      } as ExcelFieldConfig;
    })
    .filter((gc) => !excludeColumns.find((c) => c === gc.name));
};

export function tabDownloadExcel<T>(
  sharedFacade: SharedFacadeInterface<T>,
  gridColumns: EntityListField[],
  excludeColumns: string[],
  columnState: ColumnState[],
  fileName: string,
  filters: FilterValue[],
  limitedRelations?: string[],
) {
  const columns = getExcelFields(gridColumns, columnState, excludeColumns);
  const sort = mapFromColumnState(columnState);
  sharedFacade.downloadExcel(
    fileName,
    columns,
    filters,
    sort,
    limitedRelations,
  );
}
